import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=825e7e3a&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style1 from "./Search.vue?vue&type=style&index=1&id=825e7e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825e7e3a",
  null
  
)

export default component.exports